export const ERROR_MESSAGE_TRY_AGAIN_LATER = "しばらくしてから再度お試しください。" as const;
